const isFirstPartyFrame = (frame) => {
  if (!frame) return false
  if (frame.inProject === true || frame.in_project === true) return true
  if (typeof frame.file !== 'string') return false
  if (frame.file.startsWith('webpack://')) return true
  if (/^https?:\/\/([^/]*\.)?mtggoldfish\.com\/(assets|packs|javascripts)\//.test(frame.file)) return true
  if (/^https?:\/\/([^/]*\.)?mtggoldfish\.com\/.*\.js(\?|#|$)/.test(frame.file)) return true
  return false
}

const THIRD_PARTY_PATTERNS = [
  /Throttled is not defined|can't find variable: Throttled/i,
  // NOTE: "$ is not defined" removed — ad-blockers or broken third-party scripts
  // can shadow globals; keeping this unfiltered avoids masking first-party errors.
  // NOTE: "Image is not a constructor" removed — we use new Image() in visual_deck.js and
  // CardGraph.js; an ad script redefining Image could cause this to fire from our code.
  /track is not defined|can't find variable: track/i,
  /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/i,
  /window\.__gpp is not a function/,
  /\.refreshUserIds is not a function/,
  /NS_ERROR_(UNEXPECTED|NOT_INITIALIZED|FAILURE)/,
  /this\._global\[this\._globalBindingName\] is not a function/,
  /unhandledrejection handler received a non-error/i,
  /Loading chunk \d+ failed.*(?:vntsm|venatusmedia)\.com/i,
  // Venatus-injected tournament footer scripts can run without their CONFIG global in iOS webviews.
  /(?:CONFIG is not defined|can't find variable: CONFIG)/i,
  // MTG-353: Firefox can deny Stimulus's MutationObserver access to node.nodeType
  // when third-party ad DOM exposes a cross-origin security wrapper.
  /^Permission denied to access property "nodeType"$/i,
  /Failed to execute 'appendChild' on 'Node': Unexpected identifier 'disallow'/,
  /Failed to execute 'replaceWith' on 'Element': Unexpected identifier/,
  /^Request aborted$/,
]

const AD_NETWORK_DOMAINS = /\b(venatusmedia\.com|vntsm\.com|cpx\.to|cadmus\.script\.ac|hb\.vntsm\.com|zeotap\.com|rlcdn\.com)\b/

const hasAdNetworkFrame = (frames) =>
  frames.some(frame => typeof frame?.file === 'string' && AD_NETWORK_DOMAINS.test(frame.file))

// Bots that spoof Chrome but use a zero patch version (e.g. Chrome/113.0.0.0) trigger
// moment.js initialization errors from a hardened V8 runtime. Discard all events from
// these user agents — they are not real user-impacting errors.
const BOT_UA_PATTERN = /Chrome\/\d+\.0\.0\.0/

const isBotUserAgent = (ua = navigator.userAgent) => BOT_UA_PATTERN.test(ua)

export { isFirstPartyFrame, THIRD_PARTY_PATTERNS, AD_NETWORK_DOMAINS, hasAdNetworkFrame, isBotUserAgent }
